export default "__VITE_ASSET__DyyffPjb__"